import React, { Fragment } from "react";
import { Descriptor } from "./Descriptor";
import { Title } from "./Title";
export const SectionHeader = ({ title, subtitle, children, results, titleLevel = "h2", tooltip, }) => {
    return (React.createElement("div", { className: "d-flex section-header align-items-baseline" },
        React.createElement(Title, { titleLevel: titleLevel },
            React.createElement(Fragment, null,
                title,
                " ",
                results && `(${results})`,
                subtitle && React.createElement("small", null,
                    " ",
                    subtitle))),
        tooltip && (React.createElement("span", { className: "ml-2" },
            React.createElement(Descriptor, { message: tooltip, placement: "top", icon: "question-sign", color: "#757575" }))),
        children && React.createElement("div", null, children)));
};
